var _circle, _circle2, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeachers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28,
    r: 28,
    fill: "#F4F7FE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9997,
    cy: 32.7497,
    r: 2.66667,
    stroke: "url(#paint0_linear_4712_32391)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0833 37.4997H14.75C14.1977 37.4997 13.75 37.052 13.75 36.4997V16.333C13.75 15.7807 14.1977 15.333 14.75 15.333H41.25C41.8023 15.333 42.25 15.7807 42.25 16.333V36.4997C42.25 37.052 41.8023 37.4997 41.25 37.4997H35.9167",
    stroke: "url(#paint1_linear_4712_32391)",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.667 42.25C21.9309 40.6667 22.9337 37.5 24.8337 37.5C26.7337 37.5 29.8475 37.5 31.167 37.5C31.9587 37.5 33.7003 38.45 34.3337 42.25",
    stroke: "url(#paint2_linear_4712_32391)",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5656 23.3325L31.0096 25.8015C31.0782 25.8396 31.0782 25.9382 31.0096 25.9763L26.5656 28.4452C26.4989 28.4823 26.417 28.4341 26.417 28.3578V23.42C26.417 23.3437 26.4989 23.2955 26.5656 23.3325Z",
    stroke: "url(#paint3_linear_4712_32391)",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4712_32391",
    x1: 24.833,
    y1: 29.583,
    x2: 31.1663,
    y2: 35.9163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4712_32391",
    x1: 13.75,
    y1: 15.333,
    x2: 35.2346,
    y2: 42.9561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4712_32391",
    x1: 21.667,
    y1: 37.5,
    x2: 24.7903,
    y2: 45.8288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4712_32391",
    x1: 26.417,
    y1: 23.25,
    x2: 31.6656,
    y2: 27.9738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeachers);
export default __webpack_public_path__ + "static/media/teachers.8c94e67a1d3e2d4a8ce7535a0091d6df.svg";
export { ForwardRef as ReactComponent };